export default __webpack_public_path__ + "static/media/virtual_group_bgSmall.2bb57515.jpg";